const ONE_MINUTE_IN_SECONDS = 60;
const INITIAL_TIME_IN_SECONDS = 8 * ONE_MINUTE_IN_SECONDS - 1; // 7:59

export enum CHECKOUT_TIMER_STATUSES {
  NOT_STARTED = 'not_started',
  RUNNING = 'running',
  ENDED = 'ended',
  CLEARED = 'cleared',
}

export enum CLOSE_SOURCES {
  TIMEOUT = 'timeout',
  GENERIC = 'generic',
  USER = 'user',
}

export const DEFAULT_CHECKOUT_TIMER_DATA = {
  timeLeft: INITIAL_TIME_IN_SECONDS,
  status: CHECKOUT_TIMER_STATUSES.NOT_STARTED,
};
